import './App.css';
import React from 'react';
import { Header } from '../Header/Header';
import { Menu } from '../Menu/Menu';
import { menuInfo } from '../../util/data';
import { MenuSelector } from '../MenuSelector/MenuSelector';
import { ItemForm } from '../ItemForm/ItemForm';
import { Orders } from '../Orders/Orders';
import Time from '../../util/Time';

export class App extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        menu: menuInfo.lunch,
        showSelected: false,
        selectedItem: {},
        lunchOrder: {
          name: '',
          email: '',
          orderTime: '',
          itemName: '',
          itemComments: []
        },
        lunchOrderTime: '11:30 PM',
        dinnerOrder: {
          name: '',
          email: '',
          orderTime: '',
          itemName: '',
          itemComments: []
        },
        dinnerOrderTime: '5:00 PM',
        showOrders: false,
        allowOrders: true,
        loggedIn: true,
        userName: '',
        mealTime: ''
      };
      this.showModal = this.showModal.bind(this);
      this.hideModal = this.hideModal.bind(this);
      this.confirmOrder = this.confirmOrder.bind(this);
      this.handleLogin = this.handleLogin.bind(this);
      this.setMealTime = this.setMealTime.bind(this);
      this.showOrders = this.showOrders.bind(this);
      this.hideOrders = this.hideOrders.bind(this);
      this.setOrderTime = this.setOrderTime.bind(this);
    }
    componentDidMount() {
      if(Time.getMealTime() === "Lunch") {
        this.setMealTime('Lunch');
        console.log("Lunch");
      }
      else {
        this.setMealTime('Dinner');
        console.log("Dinner");
      }
    }
    setMealTime(meal)  {
      if(meal === 'dinner' || meal === 'Dinner') {
        this.setState({menu: menuInfo.dinner});
        this.setState({mealTime: 'Dinner'});
        if(this.state.dinnerOrder.name === '') {
          this.setState({allowOrders: true})
        }
      }
      else {
        this.setState({menu: menuInfo.lunch})
        this.setState({mealTime: 'Lunch'});
        if(this.state.lunchOrder.name === '') {
          this.setState({allowOrders: true})
        }
      }
    }
    setOrderTime(time) {
      if(this.state.allowOrders) {
        if(this.state.mealTime === 'Lunch') {
          this.setState({lunchOrderTime: time});
        }
        else {
          this.setState({dinnerOrderTime: time});
        }
      }
    }
    handleLogin(loginStatus, name) {
      this.setState({
        loggedIn: loginStatus,
        userName: name
      });
      document.body.style.overflow = 'unset';
    }
    showModal(category, item) {
      this.setState({showSelected: true});
      this.setState({selectedItem: this.state.menu[category].find(pred => pred.name === item)});
      document.body.style.overflow = 'hidden';
    }
    hideModal() {
      this.setState({showSelected: false});
      document.body.style.overflow = 'unset';
    }
    confirmOrder(newOrder) {
      if(this.state.mealTime === 'Lunch') {
        this.setState({lunchOrder: newOrder});
      }
      else {
        this.setState({dinnerOrder: newOrder});
      }
      this.setState({allowOrders: false});
    }
    showOrders() {
      this.setState({showOrders: true});
    }
    hideOrders() {
      this.setState({showOrders: false});
    }
    render() {
        return (
          <div id = "app" className = "app">
            <div className="app-body">
            <Header loggedIn = {this.state.loggedIn} name = {this.state.userName} showOrders = {this.showOrders}/>
            {!this.state.showOrders && <div className = "app-content">
                <MenuSelector setMealTime = {this.setMealTime} mealTime = {this.state.mealTime} setOrderTime = {this.setOrderTime}/>
                <Menu mealTime = {this.state.mealTime} showModal = {this.showModal} menu = {this.state.menu} />
            </div>}
            <ItemForm show = {this.state.showSelected} hideModal = {this.hideModal} allowOrders = {this.state.allowOrders} confirmOrder = {this.confirmOrder} showOrders = {this.showOrders} item = {this.state.selectedItem}/>
            <Orders lunchOrder = {this.state.lunchOrder} dinnerOrder = {this.state.dinnerOrder} show = {this.state.showOrders} hideOrders = {this.hideOrders} lunchOrderTime = {this.state.lunchOrderTime}
            dinnerOrderTime = {this.state.dinnerOrderTime}/>
          </div>
          </div>
          );
    }
}

export default App;
